module.exports = __webpack_public_path__ + "img/a1.29a73dd4.jpg";